import { createTheme } from '@mui/material';
import getDesignTokens, { themeTypes } from './getDesignTokens';
/**
 * Default Theme
 */

const theme = (props: themeTypes) => createTheme(getDesignTokens(props));

export default theme;
